module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("WXKbt"))).then(() => module.bundle.root('ikE14'));